<template>
  <div class="membership-controls">
    <el-button type="primary" class="fill-up-button white-button" @click="requestMembership" v-if="isNothing" plain>
      <fa icon="user-plus" style="margin-right: 10px;" />
      Request membership
    </el-button>
    <el-button type="primary" class="fill-up-button white-button" @click="cancelMembership" v-if="isPending" icon="el-icon-loading" plain>
      Pending...
    </el-button>
    <div class="invited" v-if="isInvited">
      <el-button type="primary" class="fill-up-button white-button" @click="cancelMembership" icon="el-icon-close" plain>
        Decline
      </el-button>
      <el-button type="primary" class="fill-up-button white-button" @click="acceptMembership" icon="el-icon-check" plain>
        Accept
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembershipControls',
  props: {
    pending: {
      type: Boolean,
      required: true
    },
    invite: {
      type: Boolean,
      required: true
    },
    member: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isNothing () {
      return !this.bindInvite && !this.bindPending && !this.bindMember
    },
    isInvited () {
      return this.bindInvite && !this.bindPending && !this.bindMember
    },
    isPending () {
      return this.bindPending && !this.bindInvite && !this.bindMember
    }
  },
  watch: {
    member (val) {
      this.bindMember = val
    },
    invite (val) {
      this.bindInvite = val
    },
    pending (val) {
      this.bindPending = val
    }
  },
  data () {
    return {
      bindPending: this.pending,
      bindInvite: this.invite,
      bindMember: this.member
    }
  },
  methods: {
    async requestMembership () {
      const data = { userId: this.$auth.user.id, pending: true, invite: false }
      const response = await this.$http.post(this.$api.organizations.users.create(this.$route.params.orgId), data)
      this.$message.success('Membership request sent')
      this.bindPending = true
    },
    async cancelMembership () {
      const response = await this.$http.delete(this.$api.organizations.users.delete(this.$route.params.orgId, this.$auth.user.id))
      this.bindPending = false
      this.bindInvite = false
    },
    async acceptMembership () {
      const data = { pending: false, invite: false }
      const response = await this.$http.put(this.$api.organizations.users.update(this.$route.params.orgId, this.$auth.user.id, true), data)
      this.bindMember = true
      this.bindPending = false
      this.bindInvite = false
    }
  }
}
</script>

<style lang="scss" scoped>

  .invited {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/user/organization/MembershipControls.vue